document.addEventListener('DOMContentLoaded', () => {
    console.log("Drew Testing");
    const splitBtn = document.getElementById('c1-checkout-instock-now');
    const loadDelayedBtn = document.getElementById('c1-load-delayed-cart');
    const noteEl = document.getElementById('c1-cart-split-note');
    const dynamicMessageEl = document.getElementById('c1-split-dynamic-message');
    const splitBox = document.querySelector('.c1-cart-split-box');

    const STORAGE_KEY = 'cinema1_delayed_cart_items';

    let FREE_SHIPPING_THRESHOLD = 15000;
    let CART_TOTAL = 0;
    let CART_HAS_FREE_SHIPPING = false;

    function formatMoney(cents) {
        return (cents / 100).toLocaleString('en-CA', {
        style: 'currency',
        currency: 'CAD'
        });
    }

    function showNote(message) {
        if (!noteEl) return;
        noteEl.textContent = message;
        noteEl.style.display = 'block';
    }

    function showDynamicMessage(message) {
        if (!dynamicMessageEl) return;
        dynamicMessageEl.textContent = message;
        dynamicMessageEl.style.display = 'block';
    }

    function getStatusNodes() {
        return Array.from(document.querySelectorAll('.c1-cart-item-status'));
    }

    function getDelayedItemsFromDOM() {
        return getStatusNodes()
        .filter((node) => node.dataset.instock !== 'true')
        .map((node) => ({
            lineKey: node.dataset.lineKey,
            variantId: Number(node.dataset.variantId),
            quantity: Number(node.dataset.quantity),
            preorder: node.dataset.preorder === 'true',
            backorder: node.dataset.backorder === 'true'
        }));
    }

    async function addItems(items) {
        const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: items.map(item => ({
            id: item.variantId,
            quantity: item.quantity
            }))
        })
        });

        if (!response.ok) {
        throw new Error('Cart add failed.');
        }

        return response.json();
    }

    function refreshLoadDelayedButton() {
            console.log('Checking localStorage...');
        if (!loadDelayedBtn) return;

        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            console.log("saved: " + saved);
            if (!saved) {
            loadDelayedBtn.style.display = 'none';
            return;
            }

            const parsed = JSON.parse(saved);
            console.log('Parsed delayed items:', parsed);
            console.log('Parsed delayed items length:', parsed.length);

            if (Array.isArray(parsed) && parsed.length > 0) {
                loadDelayedBtn.classList.remove('c1-hidden');
                loadDelayedBtn.classList.add('c1-visible');
            } else {
                loadDelayedBtn.classList.remove('c1-visible');
                loadDelayedBtn.classList.add('c1-hidden');
            }
        } catch (e) {
            console.error('Invalid delayed cart data', e);
            loadDelayedBtn.style.display = 'none';
        }
    }

    refreshLoadDelayedButton();

    if (loadDelayedBtn) {
        loadDelayedBtn.addEventListener('click', async () => {
            try {
            const saved = localStorage.getItem(STORAGE_KEY);

            if (!saved) {
                showNote('No delayed items are saved right now.');
                return;
            }

            const delayedItems = JSON.parse(saved);

            if (!Array.isArray(delayedItems) || delayedItems.length === 0) {
                showNote('No delayed items are saved right now.');
                return;
            }

            loadDelayedBtn.disabled = true;
            loadDelayedBtn.textContent = 'Loading delayed items...';

            await addItems(delayedItems);

            localStorage.removeItem(STORAGE_KEY);
            window.location.href = '/cart';
            } catch (error) {
            console.error(error);
            loadDelayedBtn.disabled = false;
            loadDelayedBtn.textContent = 'Load delayed items back into cart';
            showNote('Something went wrong while rebuilding the delayed cart.');
            }
        });
    }

    if (splitBtn && splitBox) {

    FREE_SHIPPING_THRESHOLD = Number(splitBox.dataset.freeShippingThreshold || 15000);
    CART_TOTAL = Number(splitBox.dataset.cartTotal || 0);
    CART_HAS_FREE_SHIPPING = splitBox.dataset.cartHasFreeShipping === 'true';

    function getInStockItemsFromDOM() {
        return getStatusNodes()
        .filter((node) => node.dataset.instock === 'true')
        .map((node) => ({
            lineKey: node.dataset.lineKey,
            variantId: Number(node.dataset.variantId),
            quantity: Number(node.dataset.quantity)
        }));
    }

    async function fetchCart() {
        const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
        });

        if (!response.ok) {
        throw new Error('Could not load cart.');
        }

        return response.json();
    }

    async function updateCartByKey(updates) {
        const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
        });

        if (!response.ok) {
        throw new Error('Cart update failed.');
        }

        return response.json();
    }

    async function clearCart() {
        const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        }
        });

        if (!response.ok) {
        throw new Error('Cart clear failed.');
        }

        return response.json();
    }

    async function updateDynamicShippingMessage() {
        try {
        const cart = await fetchCart();
        const inStockVariantIds = getInStockItemsFromDOM().map(item => item.variantId);

        if (!inStockVariantIds.length) return;

        let inStockSubtotal = 0;

        cart.items.forEach(item => {
            if (inStockVariantIds.includes(item.variant_id)) {
            inStockSubtotal += item.final_line_price;
            }
        });

        if (CART_HAS_FREE_SHIPPING && inStockSubtotal < FREE_SHIPPING_THRESHOLD) {
            const gap = FREE_SHIPPING_THRESHOLD - inStockSubtotal;
            showDynamicMessage(
            `If you split this order now, your in-stock items would total ${formatMoney(inStockSubtotal)}. Shipping may apply unless you add ${formatMoney(gap)} more in-stock product.`
            );
        } else if (inStockSubtotal >= FREE_SHIPPING_THRESHOLD) {
            showDynamicMessage(
            `Your in-stock items total ${formatMoney(inStockSubtotal)} and should still qualify for free shipping.`
            );
        } else if (!CART_HAS_FREE_SHIPPING) {
            const gap = FREE_SHIPPING_THRESHOLD - inStockSubtotal;
            showDynamicMessage(
            `Your in-stock items total ${formatMoney(inStockSubtotal)}. Add ${formatMoney(gap)} more in-stock product to reach free shipping.`
            );
        }
        } catch (error) {
        console.error(error);
        }
    }

    splitBtn.addEventListener('click', async () => {
        try {
        const delayedItems = getDelayedItemsFromDOM();
        const inStockItems = getInStockItemsFromDOM();

        if (inStockItems.length === 0) {
            showNote('There are no in-stock items in this cart yet.');
            return;
        }

        if (delayedItems.length === 0) {
            window.location.href = '/checkout';
            return;
        }

        console.log('Delayed items:', delayedItems);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(delayedItems));

        const updates = {};
        delayedItems.forEach(item => {
            updates[item.lineKey] = 0;
        });

        splitBtn.disabled = true;
        splitBtn.textContent = 'Preparing in-stock checkout...';

        await updateCartByKey(updates);

        window.location.href = '/checkout';
        } catch (error) {
        console.error(error);
        splitBtn.disabled = false;
        splitBtn.textContent = 'Checkout in-stock items now';
        showNote('Something went wrong while splitting the cart.');
        }
    });

    
    updateDynamicShippingMessage();
    }
    const observer = new MutationObserver(() => {
  refreshLoadDelayedButton();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
});